<template>
  <v-dialog
    v-model="showModal"
    max-width="360"
    :persistent="true"
    @input="close"
  >
    <naj-box
      :disable-collapsing="true"
      no-bottom-margin
      has-footers
    >
      <div class="confirmation-content">
        <v-icon
          :color="color == 'error'?'#89743e':'green'"
          class="confirmation-icon"
        >
          {{ color == 'error'? 'mdi-alert-outline' :'mdi-check-circle-outline' }}
        </v-icon>
        <h5>{{ title }}</h5>
      </div>
      <div class="message">
        {{ message }}
      </div>

      <template v-slot:footer>
        <div class="naj-modal-actions">
          <naj-button
            color="primary"
            @click="close"
          >
            {{ closeBtnLabel || local.common.close }}
          </naj-button>
          <naj-button
            v-if="okBtnLabel"
            :color="color"
            :loading="actionLoading"
            @click="$emit('ok')"
          >
            {{
              okBtnLabel
            }}
          </naj-button>
        </div>
      </template>
    </naj-box>
  </v-dialog>
</template>

<script>
export default {
  name: 'NajConfirmation',
  props: ['showModal', 'color', 'title', 'message', 'okBtnLabel', 'closeBtnLabel', 'actionLoading'],
  methods: {
    close() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
.message {
  font-size: 18px;
  font-weight: 400;
  color: #6c757d;
  text-align: center;
}
.naj-modal-actions {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: flex-end;
  width: 100%;
}

.v-dialog__content {
  .header-slot {
    display: none;
  }
  ::v-deep {
    .naj-box-content {
      padding: 18px;
      .row {
        margin-left: 0;
        margin-right: 0;
        .col {
          padding-top: 0;
        }
      }
    }
    .naj-box-header {
      display: none;
    }
    .confirmation-content {
      color: #343a40;
      font-weight: 600;
      display: block !important;
      font-size: 20px;
      text-align: center !important;
      h5 {
        margin: 10px 0;
      }
    }
    .confirmation-icon {
      margin: 10px 0;
      color: #343a40;
      font-weight: 600;
      font-size: 36px;
    }
  }
}

::v-deep {
  .naj-box .naj-box-footer {
    border-top: none;
    background-color: transparent;
    .naj-modal-actions {
      justify-content: center;
    }
  }
}
</style>
